import UnknownPage from "features/Unknown/UnknownPage";
import { lazy } from "react";

class AppPages {
  static PAGES: { [key: string]: any } = {
    SignInPage: lazy(() => import("features/SignIn/view/SignInPage")),
    ForgotPassword: lazy(() => import("features/SignIn/view/ForgotPassword")),
    AccountInformationPage: lazy(
      () => import("features/Account/view/AccountInformationPage"),
    ),
    ChangePassPage: lazy(() => import("features/Account/view/ChangePassword")),

    //new
    DKTTB: lazy(() => import("features/Order/view/DKTTBPage")),
    PremiumNumber: lazy(() => import("features/Order/view/PremiumNumber")),
    KeepNumber: lazy(() => import("features/Order/view/KeepNumber")),
    NumberCartPage: lazy(
      () => import("features/Order/view/shoppingCart/number/NumberCartPage"),
    ),
    PremiumNumberCartPage: lazy(
      () =>
        import("features/Order/view/shoppingCart/number/PremiumNumberCartPage"),
    ),
    NegotiationPage: lazy(() => import("features/Order/view/NegotiationPage")),
    AddPackage: lazy(() => import("features/Order/view/AddPackagePage")),
    TopupOrder: lazy(() => import("features/TopUp/view/TopUpOrder")),
    TransactionMer: lazy(
      () => import("features/Transaction/view/TransactionMer"),
    ),
    Transaction: lazy(() => import("features/Transaction/view/Transaction")),
    LimitPage: lazy(() => import("features/Transaction/view/Limit")),
    SimPublic: lazy(() => import("features/Sim/view/SimPublic")),
    SimPremium: lazy(() => import("features/Sim/view/SimPremium")),
    SimPrivate: lazy(() => import("features/Sim/view/SimPrivate")),
    SimEmbryo: lazy(() => import("features/Sim/view/SimEmbryo")),
    PackegeMr: lazy(() => import("features/Packege/view/PackegeMr")),
    MrPage: lazy(() => import("features/User/view/MerPage")),
    AdminMerPage: lazy(() => import("features/User/view/AdminMerPage")),
    RosePage: lazy(() => import("features/Rose/view/RosePage")),
    CommissionStatementPage: lazy(
      () => import("features/CommissionStatement/view/CommissionStatementPage"),
    ),
    DashBoardPage: lazy(() => import("features/Dashboard/view/Dashboard")),
    DetailPage: lazy(() => import("features/Detail/view/DetailPage")),
    UserManagementPage: lazy(() => import("features/User/view/UserManagement")),
    ClientPage: lazy(() => import("features/Client/view/ClientPage")),
    DataOrder: lazy(() => import("features/TopUp/view/DataOrder")),
    TopupPage: lazy(() => import("features/ManageTopup/view/Topup")),
    CardPage: lazy(() => import("features/ManageTopup/view/Card")),
    DataPage: lazy(() => import("features/ManageTopup/view/Data")),
    MaintenancePage: lazy(() => import("features/Maintenance/view/MaintenancePage")),
  };

  static getPage(key: string): any {
    return this.PAGES[key] || UnknownPage;
  }
}

export const DEFAULT_PAGES = {
  SignInPage: lazy(() => import("features/SignIn/view/SignInPage")),
  ForgotPassword: lazy(() => import("features/SignIn/view/ForgotPassword")),
};

export default AppPages;
